const RGF = () => import('../views/Rgf.vue')
const LEG = () => import('../views/Leis.vue')

export default [
  { name: 'viewRgf', path: '/legislacao/relatorios-rgf', component: RGF, meta: { acl: true } },
  { name: 'viewLeis', path: '/legislacao/leis-e-decretos', component: LEG, meta: { acl: true } }
]
